import { NgModule } from '@angular/core';
import { LucideAngularModule, LucideIconData } from 'lucide-angular';
import {
    ArrowLeft,
    ArrowRight,
    ArrowDown,
    ArrowDownRight,
    ArrowUp,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Hash,
    Bed,
    Bell,
    CreditCard,
    Building2,
    HelpCircle,
    BriefcaseBusiness,
    Calendar,
    Camera,
    Check,
    CheckCircle,
    ChevronDown,
    Circle,
    CircleDollarSign,
    Clock,
    DollarSign,
    Droplet,
    Bath,
    Book,
    Facebook,
    Filter,
    FileText,
    Globe,
    Home,
    Image,
    Images,
    Layers,
    LayoutDashboard,
    LayoutTemplate,
    Linkedin,
    Lock,
    LogIn,
    LogOut,
    MapPin,
    Maximize2,
    Menu,
    Search,
    Settings,
    Star,
    Twitter,
    User,
    UserPlus,
    UserX,
    Users,
    UsersRound,
    Instagram,
    X,
    Shield,
    ShieldCheck,
    Phone,
    Mail,
    Upload,
    UploadCloud,
    File,
    FileCheck2,
    FileImage,
    ImageOff,
    Navigation,
    Plus,
    BadgeCheck,
    BadgePercent,
    TrendingUp,
    CheckCircle2,
    Wallet,
    Eye,
    EyeOff,
    MessageSquare,
    ArrowUpRight,
    Send,
    RefreshCw,
    RefreshCcw,
    Trash2,
    PlusCircle,
    Loader2,
    ListChecks,
    SlidersHorizontal,
    Sparkles,
    ExternalLink,
    Edit2,
    Edit3,
    Info,
    Save,
    CalendarClock,
    GripVertical,
    Map,
    FileDown,
    Download,
    PenLine,
    Minus,
    Ellipsis,
    ClipboardCheck,
    ClipboardList,
    CheckSquare,
    Copy,
    Database,
    Sun,
    Moon,
    Leaf,
    Palette,
    ArrowUpDown,
    Diamond,
    Share2,
    Link,
    Ban,
    IdCard,
    Bookmark,
    XCircle,
    Zap,
    RotateCcw,
    Play,
    TriangleAlert,
    Printer,
    FolderKanban,
    FolderOpen,
  Handshake,
  House,
  Ticket,
  Headset,
  Inbox,
  CalendarPlus,
  CalendarCheck,
  MessageCircle,
  FileSignature,
  PhoneCall,
  Megaphone,
  Activity,
  CheckCheck,
  Settings2,
  BellOff,
  Briefcase,
  CircleAlert,
  Key,
  KeyRound,
  ArrowDownToLine,
  Building
} from 'lucide-angular';

const StairsIcon: LucideIconData = [['path', { d: 'M4 20h4v-4h4v-4h4v-4h4V4' }]];
const RoomIcon: LucideIconData = [
    ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
    ['path', { d: 'M10 21v-7h4v7' }],
    ['path', { d: 'M13 17h.01' }]
];

const BedroomIcon: LucideIconData = [
    [
        'path',
        {
            d: 'M2.4 5.7H17.4Q18.6 5.7 18.6 6.9V9.3H21.6Q22.8 9.3 22.8 10.5V17.1Q22.8 18.3 21.6 18.3H2.4Q1.2 18.3 1.2 17.1V6.9Q1.2 5.7 2.4 5.7Z'
        }
    ],
    ['path', { d: 'M18.6 13.5V17.1' }]
];

function toKebabCase(value: string): string {
    return value
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
        .replace(/([A-Za-z])([0-9]+)/g, '$1-$2')
        .replace(/([0-9]+)([A-Za-z])/g, '$1-$2')
        .toLowerCase();
}

const baseIcons: { [key: string]: LucideIconData } = {
    ArrowLeft,
    ArrowRight,
    ArrowDown,
    ArrowDownRight,
    ArrowUp,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Hash,
    Bed,
    Bell,
    CreditCard,
    Building2,
    HelpCircle,
    BriefcaseBusiness,
    Calendar,
    Camera,
    Check,
    CheckCircle,
    CheckSquare,
    'check-square': CheckSquare,
    ChevronDown,
    Circle,
    circle: Circle,
    CircleDollarSign,
    Clock,
    clock: Clock,
    DollarSign,
    Droplet,
    Bath,
    Book,
    Facebook,
    Filter,
    FileText,
    'file-text': FileText,
    Globe,
    globe: Globe,
    Home,
    Image,
    Images,
    images: Images,
    Layers,
    LayoutDashboard,
    LayoutTemplate,
    'layout-template': LayoutTemplate,
    Linkedin,
    Lock,
    LogIn,
    LogOut,
    MapPin,
    Maximize2,
    Menu,
    Search,
    Settings,
    Star,
    Twitter,
    User,
    UserPlus,
    UserX,
    Users,
    UsersRound,
    Instagram,
    X,
    Shield,
    ShieldCheck,
    Phone,
    Mail,
    Upload,
    UploadCloud,
    File,
    FileCheck2,
    FileImage,
    FolderKanban,
    FolderOpen,
    ImageOff,
    Navigation,
    Plus,
    BadgeCheck,
    'badge-check': BadgeCheck,
    BadgePercent,
    TrendingUp,
    CheckCircle2,
    Wallet,
    Eye,
    EyeOff,
    MessageSquare,
    ArrowUpRight,
    Send,
    RefreshCw,
    RefreshCcw,
    Trash2,
    PlusCircle,
    Loader2,
    ListChecks,
    SlidersHorizontal,
    Sparkles,
    ExternalLink,
    Edit2,
    edit: Edit2,
    'edit-2': Edit2,
    Edit3,
    'edit-3': Edit3,
    pencil: Edit3,
    pen: Edit3,
    Info,
    Save,
    CalendarClock,
    GripVertical,
    Map,
    FileDown,
    Download,
    PenLine,
    'pen-line': PenLine,
    'pencil-line': PenLine,
    Printer,
    printer: Printer,
    Minus,
    Ellipsis,
    ClipboardCheck,
    ClipboardList,
    Copy,
    Database,
    database: Database,
    'refresh-cw': RefreshCw,
    'refresh-ccw': RefreshCcw,
    book: Book,
    camera: Camera,
    copy: Copy,
    mail: Mail,
    Sun,
    Moon,
    Leaf,
    Palette,
    ArrowUpDown,
    Diamond,
    Share2,
    'share-2': Share2,
    Link,
    link: Link,
    shield: Shield,
    'shield-check': ShieldCheck,
    Ban,
    ban: Ban,
    XCircle,
    'x-circle': XCircle,
    IdCard,
    'id-card': IdCard,
    Bookmark,
    bookmark: Bookmark,
    Zap,
    zap: Zap,
    RotateCcw,
    'rotate-ccw': RotateCcw,
    Play,
    play: Play,
    TriangleAlert,
    'triangle-alert': TriangleAlert,
    Stairs: StairsIcon,
    stairs: StairsIcon,
    Room: RoomIcon,
    room: RoomIcon,
  Bedroom: BedroomIcon,
  bedroom: BedroomIcon,
  Handshake,
  handshake: Handshake,
  House,
  house: House,
  Ticket,
  ticket: Ticket,
  Headset,
  headset: Headset,
  Inbox,
  inbox: Inbox,
  CalendarPlus,
  'calendar-plus': CalendarPlus,
  CalendarCheck,
  'calendar-check': CalendarCheck,
  MessageCircle,
  'message-circle': MessageCircle,
  FileSignature,
  'file-signature': FileSignature,
  PhoneCall,
  'phone-call': PhoneCall,
  Megaphone,
  megaphone: Megaphone,
  Activity,
  activity: Activity,
  CheckCheck,
  'check-check': CheckCheck,
  Settings2,
  'settings-2': Settings2,
  BellOff,
  'bell-off': BellOff,
  Briefcase,
  briefcase: Briefcase,
  CircleAlert,
  'circle-alert': CircleAlert,
  'alert-circle': CircleAlert,
  Key,
  key: Key,
  KeyRound,
  'key-round': KeyRound,
  ArrowDownToLine,
  'arrow-down-to-line': ArrowDownToLine,
  Building,
  building: Building
};

const icons: { [key: string]: LucideIconData } = Object.entries(baseIcons).reduce((acc, [key, icon]) => {
    acc[key] = icon;
    const kebabKey = toKebabCase(key);
    if (kebabKey && !acc[kebabKey]) acc[kebabKey] = icon;
    const lowerKey = key.toLowerCase();
    if (lowerKey && !acc[lowerKey]) acc[lowerKey] = icon;
    return acc;
}, {} as { [key: string]: LucideIconData });

icons['pencil-line'] = PenLine;
icons['pencilLine'] = PenLine;

@NgModule({
    imports: [LucideAngularModule.pick(icons)],
    exports: [LucideAngularModule]
})
export class LucideIconsModule { }
